import { userByIdOptions } from "@/api/queryApi";
import { LanguageSelector } from "@/features/header/toolbar/LanguageSelector";
import Pfp from "@/features/header/toolbar/Pfp";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faSignOutAlt } from "@fortawesome/sharp-regular-svg-icons";
import { useQuery } from "@tanstack/react-query";
import {
    DropdownMenu,
    DropdownMenuContent,
    DropdownMenuGroup,
    DropdownMenuItem,
    DropdownMenuLabel,
    DropdownMenuSeparator,
    DropdownMenuTrigger,
} from "frontend-components";
import { useJwt, useLogout } from "frontend-auth";
import { useTranslation } from "react-i18next";

export function UserButton() {
    const { userId } = useJwt();
    const { data: user } = useQuery(userByIdOptions({ id: userId }));
    const logout = useLogout();
    const { t } = useTranslation();
    return (
        <DropdownMenu>
            <DropdownMenuTrigger className="w-8 h-8 rounded-full overflow-hidden bg-secondary ring-0   focus:ring-2 focus:ring-slate-300 flex items-center justify-center">
                {userId && <Pfp userId={userId} />}
            </DropdownMenuTrigger>
            <DropdownMenuContent align="end" className="w-54">
                <DropdownMenuGroup>
                    <DropdownMenuLabel>
                        {user?.firstName} {user?.lastName}
                    </DropdownMenuLabel>
                    <DropdownMenuSeparator />
                    <LanguageSelector />
                    <DropdownMenuItem onClick={logout}>
                        <FontAwesomeIcon icon={faSignOutAlt} />
                        {t("common.logout")}
                    </DropdownMenuItem>
                </DropdownMenuGroup>
            </DropdownMenuContent>
        </DropdownMenu>
    );
}
